export { default } from "./background-image";
export * from "./types";
